<script setup lang="ts">
import { useMatomoViewportTrack } from '~/composables/useMatomo'

const mobileApp = ref<HTMLElement | null>(null)

onMounted(() => {
    if (mobileApp.value !== null) {
        useMatomoViewportTrack(mobileApp.value, {
            category: 'AppBanner',
            action: 'view',
        })
    }
})

const sendClickEvent = (version: string) => {
    if (window._paq) {
        window._paq.push(['trackEvent', 'AppBanner', 'click', version])
    }
}

const mobileAppUrl = useMobileAppLink()
</script>

<template>
    <div ref="mobileApp" class="mobile-app-banner">
        <div class="mobile-app-banner__content">
            <h2 class="mobile-app-banner__title">
                {{ $t('mobileApp.homepageBanner.easierShoppingWithPilulkaApp') }}
            </h2>

            <div class="mobile-app-banner__line">
                <img src="/nuxt-assets/images/icons/check-circle.svg" alt="verified" width="13" height="13" loading="lazy" />
                <span>{{ $t('mobileApp.homepageBanner.quickAndRepeatedPurchaseViaOneClick') }}</span>
            </div>

            <div class="mobile-app-banner__line">
                <img src="/nuxt-assets/images/icons/check-circle.svg" alt="verified" width="13" height="13" loading="lazy" />
                <span>{{ $t('mobileApp.homepageBanner.discountsAndBetterPricesInApp') }}</span>
            </div>

            <div class="mobile-app-banner__line">
                <img src="/nuxt-assets/images/icons/check-circle.svg" alt="verified" width="13" height="13" loading="lazy" />
                <span>{{ $t('mobileApp.homepageBanner.youKnowExactlyWhereYourOrderIs') }}</span>
            </div>
        </div>

        <div class="mobile-app-banner__link-wrapper">
            <img src="/nuxt-assets/images/png/one-link-app.png" class="me-4 mobile-app-banner__qr" alt="qr_code" width="100" height="100" />

            <div class="mobile-app-banner__links mb-2">
                <a
                    class="mobile-app__get-app"
                    :href="mobileAppUrl"
                    :title="$t('mobileApp.android.alt')"
                    :aria-label="$t('mobileApp.android.alt')"
                    @click="sendClickEvent('android')"
                >
                    <img
                        :src="`/nuxt-assets/images/homepage/app/${$t('locale')}/get_it_on_google_play.svg?raw`"
                        :alt="$t('mobileApp.android.alt')"
                        width="160"
                        height="50"
                    />
                </a>

                <a
                    class="mobile-app__get-app"
                    :href="mobileAppUrl"
                    :title="$t('mobileApp.ios.alt')"
                    :aria-label="$t('mobileApp.ios.alt')"
                    @click="sendClickEvent('ios')"
                >
                    <img
                        :src="`/nuxt-assets/images/homepage/app/${$t('locale')}/download_on_the_app_store.svg?raw`"
                        :alt="$t('mobileApp.ios.alt')"
                        width="160"
                        height="50"
                    />
                </a>
            </div>
        </div>

        <div class="mobile-app-banner__image-wrapper">
            <img
                :src="`/nuxt-assets/images/homepage/app/${$t('header.locale')}/mobile-app.webp`"
                alt=""
                class="mobile-app-banner__phone"
                loading="lazy"
            />
        </div>
    </div>
</template>

<style lang="scss" scoped>
.mobile-app-banner {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    position: relative;

    @include screen-lg {
        margin: 5rem auto;
        box-shadow: 0 0 19px -8px #000;
        max-width: 1392px;
        padding: 3rem;
        border-radius: 10px;
        gap: 1rem;
    }

    &__title {
        color: $color-cta;
        font-size: 24px;
    }

    &__content {
        width: auto;

        @include screen-lg {
            flex: 0 0 auto;
            width: 50%;
        }
    }

    &__line {
        margin-bottom: 1rem;
        display: flex;
        align-items: flex-start;

        img {
            margin-right: 0.5rem;
            margin-top: 0.2rem;
        }
    }

    &__link-wrapper {
        width: 100%;
        max-width: 400px;

        @include screen-lg {
            display: flex;
            flex: 0 0 auto;
            width: 30%;
            max-width: 350px;
        }
    }

    &__image-wrapper {
        display: none;

        @include screen-lg {
            display: block;
            flex: 0 0 auto;
            width: 10%;
        }
    }

    &__phone {
        top: -65px;
        z-index: 90;
        position: absolute;
        display: none;
        height: 370px;

        @include screen-lg {
            display: block;
        }
    }

    &__qr {
        display: none;

        @include screen-lg {
            display: block;
        }
    }

    &__link {
        @include screen-lg {
            margin-bottom: 1.5rem;
        }
    }

    &__links {
        flex-shrink: 0;
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        align-items: center;

        @include screen-lg {
            flex-direction: column;
        }
    }
}
</style>
